import React from 'react'
import cignalLogo from '../../assets/cignal-logo.png'
import { Link } from 'react-router-dom'
import { BsTwitter, BsDiscord, BsInstagram, BsLinkedin } from "react-icons/bs";
import cignalPhone from '../../assets/cignal-phone.png'
import CountUp from "react-countup";
import VisibilitySensor from 'react-visibility-sensor'
import Footer from '../../components/Footer';
import Navbar from '../../components/Navbar';

const Home = () => {
     // Home Content Container
  return (
      <>
      {/** Navbar */}
      <Navbar />
       {/** Hero */}
    <section className="text-gray-600">
    <div className="max-w-7xl mx-auto flex px-5 py-24 md:flex-row flex-col items-center">
      <div className="lg:flex-grow md:w-1/2 md:ml-24 pt-6 flex flex-col md:items-start md:text-left mb-40 items-center text-center">
        <h1 className="heroText mb-5 sm:text-6xl text-5xl items-center xl:w-2/2 text-gray-900">
        Where Social Media
        </h1>
        <h1 className="heroText mb-5 sm:text-6xl text-5xl items-center xl:w-2/2 text-gray-900">
        & <span style={{color: 'white'}}>WEB3</span> Collide        
        </h1>
        <div className="flex justify-center">
          <Link
            className="animate-bounce inline-flex items-center px-5 py-3 mt-2 font-medium text-white transition duration-500 ease-in-out transform bg-transparent rounded-lg bg-gray-900 transition w-30 ease-in-out hover:-translate-y-1 hover:scale-110 duration-300"
            to="/join-wait-list"
          >
            <span className="justify-center">Join Waitlist</span>
          </Link>
        </div>

        <h2 className="title-font font-medium sm:text-5xl text-3xl text-white my-5">
                  <CountUp end={30000} redraw={true}>
                    {({ countUpRef, start }) => (
                      <VisibilitySensor onChange={start} delayedCall>
                        <span ref={countUpRef} />
                      </VisibilitySensor>
                    )}
                  </CountUp>
                </h2>
                <p className="leading-relaxed">30k Waitlisted</p>
      </div>
      <div className="xl:mr-44 sm:mr-0 sm:mb-28 mb-0 lg:mb-0 mr-48 md:pl-10">
        <img
          className="w-80 md:ml-1 ml-24 animate-fade-in-down"
          alt="iPhone-12"
          src={cignalPhone}
        ></img>
      </div>
    </div>
   
    {/** Web3 Native Twitter Section */}
    <div className="grr max-w-7xl pt-20 mx-auto text-center">
      <h1 className="mb-8 text-5xl md:text-6xl Avenir font-semibold text-gray-900">
      A <span className="text-white">web3 native</span> twitter
      </h1>
      <h1 className="mb-8 text-2xl md:text-2xl Avenir font-semibold text-white text-center">
<span style={{color: '#111827'}}>Connect</span> your community.  <span style={{color: '#111827', marginLeft: '.5em'}}>Unleash</span> your creative side.
      </h1>
      <div className="container flex flex-col items-center justify-center mx-auto rounded-lg ">
        {/** Tag Line Container */}
        <div className='p-2'>
            {/** Be Unique */}
            <div className='mb-5'>
                <h1 className='tagLineTitleText text-2xl font-semibold'>Be Unique</h1>
                <p className='tagLineSubText'> Connect with your audience through our social features. Powered by community.</p>
            </div>
            {/** Wallet connect */}
            <div className='mb-5'>
                <h1 className='tagLineTitleText text-2xl font-semibold'>Wallet connect</h1>
                <p className='tagLineSubText md:w-[60%] mx-auto'>Wallet connection allows you to keep track of your NFTs, tokens, and digital assets. Reward your community and so much more.</p>
            </div>
            {/** NFT Marketplace */}
            <div className='nftMarketplace mb-5'>
                <h1 className='tagLineTitleText text-2xl font-semibold'>NFT Marketplace</h1>
                <p className='tagLineSubText'>Create, buy, sell, & mint your NFTs all-in-one app.</p>
            </div>
        </div>
      </div>
    </div>
    
     {/** Coming Soon Section */}
    <section className="relative">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 text-center">
        <div className="py-24 md:py-36">
          <h1 className="mb-5 text-6xl Avenir font-semibold text-gray-900">
            Coming Soon
          </h1>
          <h1 className="mb-9 text-2xl font-semibold text-white">
           Built on the Solana blockchain
          </h1>
           <img className='rounded-full mx-auto w-20 h-20' src='https://pbs.twimg.com/profile_images/1472933274209107976/6u-LQfjG_400x400.jpg' alt="solana-logo"/>
        </div>
      </div>
    </section>

     {/** Footer */}
    <Footer />
  </section>
  </>
  )
}

export default Home